// extracted by mini-css-extract-plugin
export var widgets = "bY_gj";